import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Brain, Wrench, FileText } from 'lucide-react';
export function WhatsIncluded() {
  const phases = [{
    title: 'Evaluar el perfil mental',
    desc: 'Detectá fortalezas, áreas de mejora, respuesta al error y confianza.'
  }, {
    title: 'Planificar el trabajo',
    desc: 'Convertí la evaluación en objetivos claros y prioridades de intervención.'
  }, {
    title: 'Conducir sesiones',
    desc: 'Protocolo orientado al rendimiento: apertura, foco, herramienta y cierre.'
  }, {
    title: 'Intervenir con equipos',
    desc: 'Trabajá comunicación, liderazgo y roles sin caer en charlas genéricas.'
  }, {
    title: 'Acompañar lesiones',
    desc: 'Ordená el proceso desde el diagnóstico hasta la vuelta a la competencia.'
  }, {
    title: 'Preparar competencia',
    desc: 'Diseñá rutinas precompetitivas y comunicá avances al cuerpo técnico.'
  }];
  const tools = ['Plantillas de evaluación', 'Guías de preguntas', 'Protocolos de sesión', 'Ejercicios prácticos', 'Tareas entre sesiones', 'Checklists', 'Reportes profesionales', 'Guiones de comunicación'];
  return <section className="bg-white py-12 md:py-20" data-id="element-212">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        <div className="mx-auto max-w-3xl text-center mb-8 md:mb-12" data-id="element-214">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-display text-slate-900" data-id="element-215">
            QUÉ INCLUYE EL{' '}
            <span className="text-emerald-600" data-id="element-216">KIT PSICÓLOGO DEPORTIVO</span>
          </h2>
        </div>

        <div className="mx-auto max-w-5xl space-y-6 md:space-y-8" data-id="element-217">
          {/* Method */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="rounded-2xl md:rounded-3xl bg-slate-950 p-5 md:p-10 text-white shadow-xl" data-id="element-218">
            <div className="flex items-center gap-3 mb-6" data-id="element-219">
              <Brain className="h-8 w-8 md:h-10 md:w-10 text-emerald-400" data-id="element-220" />
              <h3 className="text-xl md:text-2xl font-bold uppercase tracking-tight" data-id="element-221">
                Método Mente y Rendimiento™
              </h3>
            </div>

            <div className="grid gap-3 md:gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3" data-id="element-222">
              {phases.map((phase, idx) => <div key={idx} className="flex gap-3 bg-slate-900/80 p-4 rounded-xl border border-slate-800" data-id="element-223">
                  <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-500/20 text-[11px] text-emerald-400 font-bold" data-id="element-224">
                    {idx + 1}
                  </div>
                  <div data-id="element-225">
                    <h4 className="font-bold text-sm md:text-base mb-1 text-white leading-tight" data-id="element-226">
                      {phase.title}
                    </h4>
                    <p className="text-slate-400 text-xs md:text-sm leading-snug" data-id="element-227">
                      {phase.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </motion.div>

          <div className="grid gap-4 md:gap-8 md:grid-cols-2" data-id="element-228">
            {/* Resources */}
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="rounded-2xl md:rounded-3xl bg-slate-50 p-6 md:p-8 border border-slate-200" data-id="element-229">
              <div className="mb-4 inline-flex h-10 w-10 md:h-12 md:w-12 items-center justify-center rounded-xl bg-blue-100 text-blue-600" data-id="element-230">
                <Wrench className="h-5 w-5 md:h-6 md:w-6" data-id="element-231" />
              </div>
              <h3 className="text-lg md:text-xl font-bold text-slate-900 mb-2 uppercase tracking-tight" data-id="element-232">
                Recursos de Intervención
              </h3>
              <p className="text-xs md:text-base text-slate-600 leading-relaxed" data-id="element-233">
                Para momentos donde el deportista se bloquea, se frustra, pierde
                confianza, se desconcentra o no sabe cómo responder bajo
                presión.
              </p>
            </motion.div>

            {/* Tools */}
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="rounded-2xl md:rounded-3xl bg-slate-50 p-6 md:p-8 border border-slate-200" data-id="element-234">
              <div className="mb-4 inline-flex h-10 w-10 md:h-12 md:w-12 items-center justify-center rounded-xl bg-emerald-100 text-emerald-600" data-id="element-235">
                <FileText className="h-5 w-5 md:h-6 md:w-6" data-id="element-236" />
              </div>
              <h3 className="text-lg md:text-xl font-bold text-slate-900 mb-3 uppercase tracking-tight" data-id="element-237">
                Herramientas Aplicables
              </h3>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-238">
                {tools.map((tool, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-239">
                    <CheckCircle2 className="h-4 w-4 shrink-0 text-emerald-500 mt-0.5" data-id="element-240" />
                    <span className="text-xs md:text-sm text-slate-700 font-medium" data-id="element-241">
                      {tool}
                    </span>
                  </li>)}
              </ul>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}